import { createFileRoute } from '@tanstack/react-router';
import { FormsRouteView } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/forms')({
  component: FormsRouteView,
});
